<template>
<div class="form-config-container">
  <el-form label-position="left" label-suffix="：" label-width="100px" style="padding-bottom: 30px">
    <el-form-item label="表名">
      <el-input placeholder="表名" v-model="data.tableName"></el-input>
    </el-form-item>
    <el-form-item label="表注释">
      <el-input placeholder="表注释" v-model="data.tableComment"></el-input>
    </el-form-item>
    <el-form-item label="标题表达式">
      <el-input v-model="data.formTitleExpression" placeholder="例:${name}_${date}" @blur="changeFormTitleExpression"></el-input>
    </el-form-item>
    <el-form-item label="Form Id" style="display: none">
      <el-input v-model="data.formId"></el-input>
    </el-form-item>
    <el-form-item label="js路径">
      <el-input type="textarea" v-model="data.jsPath" placeholder="请输入js路径"></el-input>
    </el-form-item>
    <!-- 管理部门 -->
    <el-form-item label="管理部门">
      <universal-selector v-model="data.manageOrgan" type="organ" :max="1"> </universal-selector>
    </el-form-item>
    <el-form-item label="显示步骤" v-if="!isDynamic">
      <el-switch v-model="data.showSteps"></el-switch>
    </el-form-item>
    <el-form-item label="保存跳转" v-if="!isDynamic">
      <el-switch v-model="data.saveJump"></el-switch>
    </el-form-item>
    <el-form-item label="按钮布局" v-if="!isDynamic">
        <el-radio-group v-model="data.btnLay" size="small" @change="saveAlign">
          <el-radio-button label="head">头部</el-radio-button>
          <el-radio-button label="foot">底部</el-radio-button>
        </el-radio-group>
      </el-form-item>
    <!-- 导入配置-->
    <el-divider content-position="left">导入配置</el-divider>
    <el-form-item label="导入模板">
      <el-upload ref="upload" :action="`${API_CONFIG.API_BASE_URL}/common/document/upload`" :headers="getToken()"
      :http-request="(file) => {uploadFile(file,'Import')}"
      :on-remove="(file, fileList) => {handleFileRemove(file, fileList, 'Import')}"
      :on-success="(response, file, fileList) => {handleFileSuccess(response, file, fileList, 'Import')}"
      :before-upload="handleBeforeFileUpload"
      :on-error="handleFileRrror"
      :on-preview="handPreview"
        accept=".xls,.xlsx" :limit='1' :file-list="data.templatePathFileListImport" :auto-upload="true">
        <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
      </el-upload>
    </el-form-item>
    <!-- 导出配置-->
    <el-divider content-position="left">导出配置</el-divider>
    <el-form-item label="导出模板">
      <el-upload ref="upload" :action="`${API_CONFIG.API_BASE_URL}/common/document/upload`" :headers="getToken()"
      :http-request="(file) => {uploadFile(file,'')}"
      :on-remove="(file, fileList) => {handleFileRemove(file, fileList, '')}"
      :on-success="(response, file, fileList) => {handleFileSuccess(response, file, fileList, '')}"
      :before-upload="handleBeforeFileUpload"
      :on-error="handleFileRrror"
      :on-preview="handPreview"
        accept=".xls,.xlsx" :limit='1' :file-list="data.templatePathFileList" :auto-upload="true">
        <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
      </el-upload>
    </el-form-item>
    <el-form-item label="文件名" >
      <el-input v-model="data.exportFileName" placeholder="自定义导出文件名例:${college}_${name}_贫困生认定表"></el-input>
    </el-form-item>
    <el-form-item label="execl导出" >
      <el-select v-model="data.execlExport" placeholder="请选择execl导出设置">
        <el-option label="无限制" value="notLimit"></el-option>
        <el-option label="永远不" value="never"></el-option>
        <el-option label="进行中" value="ongoing"></el-option>
        <el-option label="已完成" value="completed"></el-option>
        <el-option label="自定义" value="custom"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="execl导出条件" v-if="data.execlExport ==='custom'" >
      <el-input type="textarea" placeholder="例：${name} === '张三' && ${ldsp} === '同意'" v-model="data.execlExportConditions"></el-input>
    </el-form-item>
    <el-form-item label="pdf导出" >
      <el-select v-model="data.pdfExport" placeholder="请选择pdf导出设置">
        <el-option label="无限制" value="notLimit"></el-option>
        <el-option label="永远不" value="never"></el-option>
        <el-option label="进行中" value="ongoing"></el-option>
        <el-option label="已完成" value="completed"></el-option>
        <el-option label="自定义" value="custom"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="pdf导出条件" v-if="data.pdfExport ==='custom'" >
      <el-input type="textarea" v-model="data.pdfExportConditions"></el-input>
    </el-form-item>
    <el-divider content-position="left">基础按钮</el-divider>
    <avue-crud ref="crud" :option="baseButtonOption" :data="data.baseButtonDefaultSet"></avue-crud>
    <el-divider content-position="left">扩展按钮</el-divider>
    <ExtButton :datas="data.extButtonList" @on-data="handleUpExtButton" />
    <el-divider content-position="left">其它</el-divider>
    <el-form-item label="对齐方式" placeholder="请选择按钮位置">
      <el-select v-model="data.labelPosition">
        <el-option label="左对齐" value="left"></el-option>
        <el-option label="右对齐" value="right"></el-option>
        <el-option label="顶部对齐" value="top"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="字段宽度">
      <el-input-number v-model="data.labelWidth" :min="80" :max="200" :step="10" controls-position="right" style="width: 100%"></el-input-number>
    </el-form-item>
    <el-form-item label="项间间隔">
      <el-input-number v-model="data.gutter" :min="0" :max="60" :step="5" controls-position="right" style="width: 100%"></el-input-number>
    </el-form-item>
    <el-form-item label="执行设备" >
      <el-select v-model="data.performEquipment" placeholder="请选择执行设备">
        <el-option label="桌面端" value="pc"></el-option>
        <el-option label="移动端" value="mobile"></el-option>
        <el-option label="不限制" value="any"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="显示按钮" v-if="false">
      <el-switch v-model="data.menuBtn" active-color="#409EFF"></el-switch>
    </el-form-item>
    <el-form-item label="按钮位置" v-if="data.menuBtn">
      <el-select v-model="data.menuPostion" placeholder="请选择按钮位置">
        <el-option label="居左" value="left"></el-option>
        <el-option label="居中" value="center"></el-option>
        <el-option label="居右" value="right"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="显示提交按钮" v-if="data.menuBtn">
      <el-switch v-model="data.submitBtn" active-color="#409EFF"></el-switch>
    </el-form-item>
    <el-form-item label="提交按钮的大小" v-if="data.menuBtn && data.submitBtn">
      <el-select v-model="data.submitSize" placeholder="请选择提交按钮的大小">
        <el-option label="正常" value="medium"></el-option>
        <el-option label="小" value="small"></el-option>
        <el-option label="超小" value="mini"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="提交按钮的文字" v-if="data.menuBtn && data.submitBtn">
      <el-input v-model="data.submitText" placeholder="请输入提交按钮的文字"></el-input>
    </el-form-item>

    <el-form-item label="显示清空按钮" v-if="data.menuBtn">
      <el-switch v-model="data.emptyBtn" active-color="#409EFF"></el-switch>
    </el-form-item>
    <el-form-item label="清空按钮的大小" v-if="data.menuBtn && data.emptyBtn">
      <el-select v-model="data.emptySize" placeholder="请选择提交按钮的大小">
        <el-option label="正常" value="medium"></el-option>
        <el-option label="小" value="small"></el-option>
        <el-option label="超小" value="mini"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="清空按钮的文字" v-if="data.menuBtn && data.emptyBtn">
      <el-input v-model="data.emptyText" placeholder="请输入提交按钮的文字"></el-input>
    </el-form-item>
  </el-form>
</div>
</template>

<script>
import {
  API_CONFIG
} from '@/page/config/base_config'
import {
  getToken
} from '@/framework/util/auth'
export default {
  components: {
    ExtButton: () => import('./ExtButtons')
  },
  name: 'FormConfig',
  props: ['data'],
  data() {
    return {
      API_CONFIG,
      getToken,
      baseButtonDefaultSet: [{
        name: '保存',
        reName: '保存草稿',
        display: true,
        $cellEdit: true
      }, {
        name: '保存并提交',
        reName: '提交表单',
        display: true,
        $cellEdit: true
      }, {
        name: '审批详情',
        reName: '',
        display: true,
        $cellEdit: true
      }, {
        name: '转办',
        reName: '',
        display: true,
        $cellEdit: true
      }, {
        name: '委派',
        reName: '',
        display: true,
        $cellEdit: true
      }, {
        name: '取消委派',
        reName: '',
        display: true,
        $cellEdit: true
      }, {
        name: '加签',
        reName: '',
        display: true,
        $cellEdit: true
      }, {
        name: '减签',
        reName: '',
        display: true,
        $cellEdit: true
      }, {
        name: '抄送',
        reName: '',
        display: true,
        $cellEdit: true
      }, {
        name: '终止',
        reName: '',
        display: true,
        $cellEdit: true
      }, {
        name: '撤回',
        reName: '',
        display: true,
        $cellEdit: true
      }, {
        name: '撤回重填',
        reName: '',
        display: true,
        $cellEdit: true
      }, {
        name: '导出Excel',
        reName: '',
        display: true,
        $cellEdit: true
      }, {
        name: '导出Pdf',
        reName: '',
        display: true,
        $cellEdit: true
      }, {
        name: '催办',
        reName: '',
        display: true,
        $cellEdit: true
      }],
      baseButtonOption: {
        addBtn: false,
        editBtn: false,
        addRowBtn: true,
        cellBtn: false,
        cancelBtn: false,
        header: false,
        menu: false,
        rowHeight: 20,
        column: [{
          label: '名称',
          prop: 'name',
          width: 80
        }, {
          label: '重命名',
          prop: 'reName',
          cell: true
        }, {
          label: '显示',
          prop: 'display',
          type: 'switch',
          cell: true,
          width: 50
        }]
      }
    }
  },
  mounted() {
    if (!this.data.baseButtonDefaultSet) {
      this.data.baseButtonDefaultSet = this.baseButtonDefaultSet
      this.$forceUpdate()
    }
  },
  methods: {
    uploadFile(file, type) {
      let fd = new FormData()
      fd.append('file', file.file)
      this.$http.post('/common/document/upload', fd, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        this.$message.success('上传成功.')
        file.fileUniqueCode = res.data
        if (!this.data['templatePathFileList' + type]) this.data['templatePathFileList' + type] = []
        this.data['templatePathFileList' + type].push({
          name: file.file.name,
          fileUniqueCode: res.data
        })
      }).catch((error) => {
        this.$message.error(error.msg)
      })
    },
    changeFormTitleExpression() {
      this.data.column
        .filter(item => '${' + item.prop + '}' !== this.data.formTitleExpression)
        .filter(item => item.isDataTitle)
        .forEach(item => { item.isDataTitle = false })
      this.data.column
        .filter(item => '${' + item.prop + '}' === this.data.formTitleExpression)
        .forEach(item => { item.isDataTitle = true })
    },
    // 文件被移除的时候
    handleFileRemove(file, fileList, type) {
      this.data['templatePathFileList' + type] = []
    },
    // 文件上传成功
    handleFileSuccess(response, file, fileList, type) {
      file.fileUniqueCode = response.data
      if (!this.data['templatePathFileList' + type]) this.data['templatePathFileList' + type] = []
      this.data['templatePathFileList' + type].push({
        name: file.name,
        fileUniqueCode: response.data
      })
      this.$message.success('上传成功.')
    },
    // 文件上传失败
    handleFileRrror(err, file, fileList) {
      this.$message.error(err.msg || err.message)
    },
    handPreview(file) {
      if (file.fileUniqueCode && file.name) {
        this.$downloadFile.get('/common/document/download', {
          params: {
            fileName: file.name,
            fileUniqueCode: file.fileUniqueCode,
            doDownload: true
          }
        }).then(res => {}).catch(_ => {})
      } else {
        this.$message.error('文件已损坏')
      }
    },
    handleUpExtButton(data) {
      this.data.extButtonList = data
    }
  }

}
</script>
